import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m 15,7 c 0,1.65685 -1.3431,3 -3,3 -1.6569,0 -3,-1.34315 -3,-3 0,-1.65685 1.3431,-3 3,-3 1.6569,0 3,1.34315 3,3 z M 12,6 c -0.5523,0 -1,0.44772 -1,1 0,0.55228 0.4477,1 1,1 0.5523,0 1,-0.44772 1,-1 0,-0.55228 -0.4477,-1 -1,-1 z M 20,8 c 0,5.2083 -5.268,12.4998 -7.2543,15.0638 -0.3819,0.4931 -1.1095,0.4931 -1.4914,0 C 9.26805,20.4998 4,13.2083 4,8 4,3.58172 7.58172,0 12,0 c 4.4183,0 8,3.58172 8,8 z M 12,2 C 8.68629,2 6,4.68629 6,8 c 0,2.0557 1.08597,4.7947 2.6272,7.5461 1.12989,2.0171 2.4023,3.8653 3.3728,5.1854 0.9705,-1.3201 2.2429,-3.1683 3.3728,-5.1854 C 16.914,12.7947 18,10.0557 18,8 18,4.68629 15.3137,2 12,2 Z"
  }));
});
var DescriptiveLocation = AbstractIcon.withComponent(Icon);
DescriptiveLocation.displayName = 'DescriptiveLocation';
export default DescriptiveLocation;